import { Span } from "@tblabs/truffle";
import { Rows } from "../../../Components/Utils/Rows";
import { Order } from "../../../Models/Order";
import { AgentsProvider } from "../../../Services/Agents/AgentsProvider";
import { TimeUtils } from "../../../Utils/TimeUtils";
import { BasketCollectionPrinter } from "../../PackageToCustomer/Components/BasketCollectionPrinter";
import { PersonalPickupStepData } from "../Models/PersonalPickupStepData";


export class MeetingInfoForAdmin extends Rows
{
    constructor(_agent: AgentsProvider, order: Order, data: PersonalPickupStepData)
    {
        try
        {
            super([
                new BasketCollectionPrinter(order, data.ItemsIds),
                new Span(`🕓 ${TimeUtils.FormattedDayHour(data.PlannedDispatchTime)}`)
                    .When(data.PlannedDispatchTime, v => TimeUtils.IsTimeSet(v), _ => _.Background("none"), _ => _.Background("#ffe5e5")),
                `🗺️ ${data.MeetingPlace.value || "Miejsce jeszcze nie ustalone"}`,
                new Span(`👤 Agent: ${_agent.Get(data.AssignedAgentId.value)?.Name || "(jeszcze nie przypisany)"}`)
                    .When(data.AssignedAgentId, v => !!v, _ => _.Background("none"), _ => _.Background("#ffe5e5")),
                `🛒 ${data.BasketSum.value} zł + 💰 ${data.DepositSum.value} zł`,
                `🎓 ${data.Training.value ? "Ze szkoleniem" : "Bez szkolenia"}`,
                `${data.CustomerInfo.value}`, // Icon included in CustomerInfo
            ]);
        }
        catch (ex: any)
        {
            console.error(`Error in MeetingInfoForAdmin: ${ex.message}\n\nStack trace: ${ex.stack}\n\nData:`, data);
            throw ex;
        }
    }
}
